import { useNavigate } from 'react-router';
import { TONE_OKLCH } from '@frisk/shared';
import { PATHS } from '../../navigation';
import { t } from '../../theme';
import { useStore } from '../../store';
import { Widget, WidgetEmpty } from './Widget';

/**
 * What to cook tonight, essentially.
 *
 * The single highest-value tile: the fridge's whole reason for being on the
 * wall is that nobody remembers the yoghurt. Sorted by urgency, not by name.
 */
export function ExpiringWidget() {
  const items = useStore((s) => s.items);
  const openDetail = useStore((s) => s.openDetail);
  const navigate = useNavigate();

  const soon = items
    .filter((i) => i.expiry.days !== null && i.expiry.days <= 3)
    .sort((a, b) => (a.expiry.days ?? 0) - (b.expiry.days ?? 0));

  const urgent = items.filter((i) => i.expiry.tone === 'urgent').length;

  return (
    <Widget
      kicker="LÄUFT AB"
      onTap={() => navigate(PATHS.inhalt)}
      accessory={
        urgent > 0 ? (
          <div
            style={{
              fontFamily: t.mono,
              fontSize: 12,
              padding: '3px 10px',
              borderRadius: 999,
              background: TONE_OKLCH.urgent,
              color: 'oklch(0.2 0.05 25)',
              fontWeight: 600,
              whiteSpace: 'nowrap',
            }}
          >
            {urgent}
          </div>
        ) : null
      }
    >
      {soon.length === 0 ? (
        <WidgetEmpty>Nichts läuft in den nächsten Tagen ab.</WidgetEmpty>
      ) : (
        <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 9, overflow: 'hidden' }}>
          {soon.slice(0, 5).map((i) => (
            <div
              key={i.id}
              className="press"
              onClick={(e) => {
                e.stopPropagation();
                openDetail(i.id);
              }}
              style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}
            >
              <div
                style={{
                  width: 9,
                  height: 9,
                  flex: 'none',
                  borderRadius: 999,
                  background: TONE_OKLCH[i.expiry.tone],
                }}
              />
              <div
                style={{
                  flex: 1,
                  fontSize: 19,
                  fontWeight: 500,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                }}
              >
                {i.name}
              </div>
              <div style={{ fontSize: 16, color: t.inkFaint, whiteSpace: 'nowrap', flex: 'none' }}>
                {i.expiry.label}
              </div>
            </div>
          ))}
          {soon.length > 5 && (
            <div style={{ fontSize: 15, color: t.inkFaint, marginTop: 2 }}>+{soon.length - 5} weitere</div>
          )}
        </div>
      )}
    </Widget>
  );
}
